<template>
  <section class="small-12 medium-12 large-6 columns">
    <!-- /************* DESCRIBE THE SCOPE OF THE DAMAGE *************/ -->
    <h1 v-html="vueModel.ContentViewModel.Step3Car.StepTitle" />

    <!-- /************* WHERE IS THE CAR DAMAGED *************/ -->
    <article v-if="vueModel.CreateClaimEntity.IsPolicyHolderClaimant">
      <h3 v-html="vueModel.ContentViewModel.Step3Car.LabelAndTooltipDamageLocation" />

      <p v-html="stepModel.ProductSpecific.CarDescription" />
      <Field
        name="damage-zone-known"
        v-slot="{ field, meta }"
        v-model="stepModel.ProductSpecific.DamageZoneKnown"
      >
        <RadioGroupStacked
          v-bind="field"
          :options="damageZonesOptions"
          :model-value="stepModel.ProductSpecific.DamageZoneKnown"
          value-prop="value"
          label-prop="label"
        />
        <ValidationError
          :name="field.name"
          v-if="meta.touched && !meta.valid"
          :overrides="{ required: 'Angiv venligst' }"
        />
      </Field>

      <div
        v-if="stepModel.ProductSpecific.DamageZoneKnown"
        class="info-box info-box-align-left is-shown push-down"
        v-html="vueModel.ContentViewModel.Step3Car.DamageLocationInfoBoxText"
      />

      <damage-zones
        v-if="stepModel.ProductSpecific.DamageZoneKnown"
        id="member"
        v-model="vueModel.CreateClaimEntity.ProductSpecific.DamageZones"
        :options="stepModel.ProductSpecific.DamageZoneOptions"
        :errors="errors"
        @show-minor-damage-question="handleShowMinorDamageQuestion"
      />
    </article>
    <article v-if="showMinorDamageQuestionArticle">
      <h3 v-html="vueModel.ContentViewModel.Step3Car.LabelMinorDamage" />
      <div class="control">
        <Field
          name="minor-damage"
          v-slot="{ field, meta }"
          :rules="{ required_notnull: true }"
          v-model="stepModel.ProductSpecific.MinorDamage"
          :label="vueModel.ContentViewModel.Step3Car.ErrorMessageRepairShopSelection"
        >
          <RadioGroupStacked
            v-bind="field"
            :options="stepModel.ProductSpecific.MinorDamageOptions"
            :model-value="stepModel.ProductSpecific.MinorDamage"
            data-test="create-claim-flow-car-minor-damage"
          />
          <ValidationError :name="field.name" :overrides="{ required: 'Angiv venligst' }" />
        </Field>
      </div>
    </article>

    <!-- /************* OPTION TO FIX CAR AT LB PREFERRED REPAIR SHOP *************/ -->
    <article
      v-if="
        vueModel.CreateClaimEntity.IsPolicyHolderClaimant &&
        stepModel.ProductSpecific.FindRepairShopVisible
      "
    >
      <h3 v-html="vueModel.ContentViewModel.Step3Car.LabelAndTooltipRepairShopSelection" />

      <Field
        name="find-repair-shop"
        v-slot="{ field, meta }"
        :rules="{ required: stepModel.ProductSpecific.FindRepairShop === null }"
        v-model="stepModel.ProductSpecific.FindRepairShop"
        :label="vueModel.ContentViewModel.Step3Car.ErrorMessageRepairShopSelection"
      >
        <RadioGroupStacked
          v-bind="field"
          :options="stepModel.ProductSpecific.FindRepairShopOptions"
          :model-value="stepModel.ProductSpecific.FindRepairShop"
        />
        <ValidationError :name="field.name" v-if="meta.touched && !meta.valid" />
      </Field>
      <transition name="fade">
        <repair-shops
          v-if="stepModel.ProductSpecific.FindRepairShop"
          v-model="vueModel.CreateClaimEntity.ProductSpecific.SearchRepairShop"
          :content-model="vueModel.ContentViewModel.Step3Car"
          :tracking-vm="trackingVm"
          :questions="questions"
          :errors="errors"
          :minor-damage="stepModel.ProductSpecific.MinorDamage"
        />
      </transition>
    </article>

    <!-- /************* COUNTERPARTY *************/ -->
    <counterparty
      v-for="(counterParty, index) in vueModel.CreateClaimEntity.ProductSpecific.CounterParties"
      id="counter-parties"
      :key="'counterparty-' + index"
      v-model="vueModel.CreateClaimEntity.ProductSpecific.CounterParties[index]"
      :index="index"
      :content="vueModel.ContentViewModel.Step3Car"
      :country-code="vueModel.CreateClaimStep1Model.DefaultCountry.Id"
      :countries="vueModel.CreateClaimStep3Model.ProductSpecific.Countries"
      :claim-licenseplate="vueModel.CreateClaimEntity.ProductSpecific.CarRegistrationNumber"
      :step-model="stepModel.ProductSpecific"
      :errors="errors"
    />

    <!-- /************* INJURED PERSONS *************/ -->
    <!-- <article
      v-for="(person, index) in vueModel.CreateClaimEntity.ProductSpecific.InjuredPersons"
      id="injured-persons"
      :key="'injured-person-' + index"
    >
      <h2>Tilskadekommen person nr. {{ index + 1 }}</h2>

      <div class="control">
        <label for="" class="text-question"
          >Fornavn &nbsp;<span title="Tooltip tekst<p></p>" class="tooltip"
        /></label>
        <input
          :id="'injured-person-' + index + '-firstname'"
          v-model="person.ContactInformation.FirstName"
          :rules="'required'"
          type="text"
          :name="'injured-person-' + index + '-firstname'"
          data-vv-as="Fornavn"
        />
        <ValidationError :name="'injured-person-' + index + '-firstname'" />
      </div>

      <div class="control">
        <label for="" class="text-question"
          >Efternavn &nbsp;<span title="Tooltip tekst<p></p>" class="tooltip"
        /></label>
        <input
          :id="'injured-person-' + index + '-lastname'"
          v-model="person.ContactInformation.LastName"
          :rules="'required'"
          type="text"
          :name="'injured-person-' + index + '-lastname'"
          data-vv-as="Efternavn"
        />
        <ValidationError :name="'injured-person-' + index + '-lastname'" />
      </div>

      <div class="control">
        <label for="" class="text-question"
          >Adresse &nbsp;<span title="Tooltip tekst<p></p>" class="tooltip"
        /></label>
        <VueSelect
          :id="'injured-person-' + index + '-address'"
          v-model="person.ContactInformation.SelectedAddress"
          :rules.initial="'required'"
          :name="'injured-person-' + index + '-address'"
          :options="addressOptions"
          label="tekst"
          data-vv-as="Adresse"
          @search="getAddressOptions"
        />
        <ValidationError :name="'injured-person-' + index + '-address'" />
      </div>

      <div class="control">
        <div class="row">
          <div class="small-12 medium-4 columns">
            <label for="" class="text-question"
              >Telefon &nbsp;<span title="Tooltip tekst<p></p>" class="tooltip"
            /></label>
            <input
              :id="'injured-person-' + index + '-phone'"
              v-model="person.ContactInformation.Phone"
              :rules="{ required: true, numeric: true, min: 8 }"
              type="text"
              :name="'injured-person-' + index + '-phone'"
              data-vv-as="Telefonnummer"
              maxlength="8"
            />
            <ValidationError :name="'injured-person-' + index + '-phone'" />
          </div>
          <div class="small-12 medium-8 columns">
            <label for="" class="text-question"
              >Email &nbsp;<span title="Tooltip tekst<p></p>" class="tooltip"
            /></label>
            <input
              :id="'injured-person-' + index + '-email'"
              v-model="person.ContactInformation.Email"
              :rules="{ required: true, email: true }"
              type="text"
              :name="'injured-person-' + index + '-email'"
              data-vv-as="Email"
            />
            <ValidationError :name="'injured-person-' + index + '-email'" />
          </div>
        </div>
      </div>
    </article> -->
  </section>
</template>

<script>
import DamageZones from '../../components/DamageZones.vue';
import RepairShops from '../../components/RepairShops.vue';
import ReportClaimMixin from '../ReportClaimMixin.vue';
import ValidationError from '@/components/UI/ValidationError.vue';
import Counterparty from '../../components/Counterparty.vue';
import BaseRadioButtonsSideBySide from '@/components/Forms/BaseRadioButtonsSideBySide.vue';
import Utility from '@/common/UtilityFunctions.js';

export default {
  name: 'ClaimScope',
  components: {
    BaseRadioButtonsSideBySide,
    Counterparty,
    DamageZones,
    RepairShops,
    ValidationError
  },
  mixins: [ReportClaimMixin],
  props: {
    vueModel: {
      type: Object,
      default() {
        return {};
      }
    },
    trackingVm: {
      type: Object,
      default() {
        return {};
      }
    },
    errors: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      stepModel: this.vueModel.CreateClaimStep3Model,
      postalCode: null,
      showMinorDamageQuestion: true,
      counterParty: null
    };
  },
  computed: {
    getDamageZoneKnownList() {
      if (this.vueModel.CreateClaimEntity.ProductSpecific.CounterParties === null) {
        return null;
      }

      var DamageZoneKnownList = [];
      this.vueModel.CreateClaimEntity.ProductSpecific.CounterParties.forEach((counterparty) =>
        DamageZoneKnownList.push(counterparty.DamageZoneKnown)
      );
      return DamageZoneKnownList;
    },
    damageZonesOptions() {
      return [
        {
          value: true,
          label: this.vueModel.ContentViewModel.Step3Car.LabelAndTooltipDamagezoneKnown
        },
        {
          value: false,
          label: this.vueModel.ContentViewModel.Step3Car.LabelAndTooltipDamagezoneNotKnown
        }
      ];
    },
    showMinorDamageQuestionArticle() {
      return (
        this.showMinorDamageQuestion &&
        this.vueModel.CreateClaimEntity.IsPolicyHolderClaimant &&
        this.stepModel.ProductSpecific.FindRepairShopVisible
      );
    }
  },
  watch: {
    'stepModel.ProductSpecific.FindRepairShop': function (val) {
      this.vueModel.CreateClaimEntity.ProductSpecific.SearchRepairShop.RepairShopId = null;

      return val ? Utility.nextTickScroll('#repair-shops', this) : null;
    },
    'vueModel.CreateClaimEntity.ProductSpecific.CounterParties': {
      deep: true,
      handler(val) {
        for (var i in val) {
          this.updateAddress(
            val[i].ContactInformation.Address,
            val[i].ContactInformation.SelectedAddress
          );
        }
      }
    },
    'vueModel.CreateClaimEntity.ProductSpecific.InjuredPersons': {
      deep: true,
      handler(val) {
        for (var i in val) {
          this.updateAddress(
            val[i].ContactInformation.Address,
            val[i].ContactInformation.SelectedAddress
          );
        }
      }
    },
    'stepModel.ProductSpecific.DamageZoneKnown': function (val) {
      if (!val) {
        this.vueModel.CreateClaimEntity.ProductSpecific.DamageZones = [];
      }
    },
    getDamageZoneKnownList(val) {
      val.forEach((item, index) => {
        if (item === false) {
          this.vueModel.CreateClaimEntity.ProductSpecific.CounterParties[index].DamageZones = [];
        }
      });
    }
  },
  mounted() {
    this.postalCode = this.vueModel.CreateClaimEntity.ProductSpecific.SearchRepairShop.PostalCode;
    for (var i = 0; i < this.assetCount; i++) {
      this.damagedItems.push({
        licensePlate: '',
        make: '',
        damageZones: []
      });
    }
  },
  methods: {
    showErrorMessage(field) {
      // var error = this.errors.items.find((x) => x.field === field);
      // if (!error) {
      //   return true;
      // }
      // if (error.rule === 'required') {
      //   return false;
      // }
      // return true;
    },
    handleShowMinorDamageQuestion(showQuestion) {
      if (!showQuestion) {
        this.resetShowMinorDamageQuestion();
      }
      this.showMinorDamageQuestion = showQuestion;
    },
    resetShowMinorDamageQuestion() {
      this.$nextTick(() => {
        this.stepModel.ProductSpecific.MinorDamage = null;
        // this.$validator.reset();
      });
    }
  }
};
</script>
